import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, CheckCircle2 } from "lucide-react";
import Reveal from "../Reveal";
import { useContent } from "../../context/ContentContext";
import { mediaUrl } from "../../api";

const points = [
  "A wide network of qualified manufacturers worldwide",
  "Regulatory confidence across major global markets",
  "One dedicated team for your entire sourcing journey",
];

export default function AboutPreview() {
  const { content } = useContent();
  const images = content.images || {};
  return (
    <section className="py-20 lg:py-28">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 grid lg:grid-cols-2 gap-14 items-center">
        <Reveal className="relative order-2 lg:order-1">
          <div className="rounded-[22px] overflow-hidden ring-1 ring-black/5 shadow-[0_30px_70px_-30px_rgba(12,97,82,0.4)]">
            <img src={mediaUrl(images.labTech)} alt="Lab technicians in cleanroom" className="w-full h-[440px] object-cover" loading="lazy" />
          </div>
        </Reveal>

        <div className="order-1 lg:order-2">
          <Reveal>
            <p className="text-xs uppercase tracking-[0.2em] text-[#2ED9B8] font-medium">Why choose Novocreste</p>
            <h2 className="mt-3 font-display text-[34px] lg:text-[44px] leading-[1.08] text-foreground">
              Your strategic sourcing partner
            </h2>
            <p className="mt-5 text-[16px] leading-relaxed text-muted-foreground max-w-xl">
              Novocreste connects global healthcare companies with a wide network of qualified manufacturers,
              helping buyers move faster with regulatory confidence, commercial clarity and reliable execution.
            </p>
          </Reveal>

          <ul className="mt-7 space-y-3.5">
            {points.map((p, i) => (
              <Reveal as="li" key={p} delay={i * 90} className="flex items-start gap-3">
                <CheckCircle2 className="h-5 w-5 text-[#2ED9B8] shrink-0 mt-0.5" />
                <span className="text-[15px] text-muted-foreground">{p}</span>
              </Reveal>
            ))}
          </ul>

          <Reveal delay={120}>
            <Link
              to="/about"
              className="tap-target mt-8 inline-flex items-center gap-2 text-[#2ED9B8] font-medium hover:gap-3 transition-all"
            >
              Learn more about us <ArrowRight className="h-4 w-4" />
            </Link>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
